import { ChangeEvent, FC } from 'react';
import { useIntl } from 'react-intl';
import * as Styled from './styles';
import Checkbox from '../../UIelements/Checkbox';

type InputRadioProps = {
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  handleClick?: () => void;
  label?: string;
  name?: string;
  value?: any;
  id?: string;
  defaultChecked?: boolean;
  isChecked?: boolean;
  isDisabled?: boolean;
  translate?: boolean;
}

const InputCheckBox: FC<InputRadioProps> = (props) => {
  const intl = useIntl();
  const translate: boolean = props.translate ?? true;

  const handleCheckboxChange = (checked: boolean) => {
    const fakeEvent = {
      target: {
        value: props.value,
        checked,
      },
    } as ChangeEvent<HTMLInputElement>;

    props.onChange(fakeEvent);
  };

  return (
    <Styled.Div onClick={() => props.isDisabled ? '' : handleCheckboxChange(!props.isChecked)}>
      <Checkbox id={props.id ?? 'checkbox'} isSelected={props.isChecked} onChange={props.isDisabled ? () => { } : handleCheckboxChange} />
      {props.label ? <label htmlFor={props.id}>{translate ? intl.formatMessage({ id: props.label }) : props.label}</label> : ""}
    </Styled.Div>
  );
}

export default InputCheckBox;
